import { Directive, Input } from '@angular/core';
import { FormGroup, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';
import { MustMatch } from './must-match.validator';

@Directive({
  selector: '[mustMatch]',
  standalone: true,
  providers: [{ provide: NG_VALIDATORS, useExisting: MustMatchDirective, multi: true }]
})
export class MustMatchDirective implements Validator {
  constructor(){}

   @Input('mustMatch') mustMatch: string[] = [];
  
    validate(formGroup: FormGroup): ValidationErrors {
      return MustMatch(this.mustMatch[0], this.mustMatch[1], this.mustMatch[2] )(formGroup);
    }
}
